import React, { useEffect, useState } from 'react';
import { useCommunitySelectHistory } from '../../../hooks/use_community_select_history';
import PageCommunitySelectWrapper from '../../../components/common/page_community_select_wrapper';
import ProfileCompletenessPhotoHeader from '../../../components/profile_completeness/profile_completeness_photo_header';
import IndividualPropertyPhotos from '../../../components/assets/photos/individual_property_photos/individual_property_photos';
import MultiOrOrgPropertyPhotos from '../../../components/assets/photos/multi_or_org_property_photos';
import { PhotoFiltersContextProvider } from './property_photos_context';
import { MessagesContextProvider } from './messages_context';

interface IProps {
  nhIDs: number[];
  orgNHID: number;
}

const PropertyPhotos = ({ nhIDs, orgNHID }: IProps) => {
  const [selectedNHID, setSelectedNHID] = useState<number>(null);
  const isSinglePropertyAccount = nhIDs?.length === 1;
  const isInSinglePropertyMode = selectedNHID || isSinglePropertyAccount;

  const handleFacilitySelect = useCommunitySelectHistory((selNHID: number) => {
    setSelectedNHID(selNHID);
  });

  useEffect(() => {
    const singleNHID = nhIDs?.length === 1 ? nhIDs[0] : null;
    if (singleNHID) {
      setSelectedNHID(singleNHID);
    }
  }, [nhIDs]);

  return (
    <MessagesContextProvider>
      <PhotoFiltersContextProvider>
        <PageCommunitySelectWrapper
          label={'All Photos for'}
          handleSelect={handleFacilitySelect}
          selNHID={selectedNHID}
          />
        <ProfileCompletenessPhotoHeader
          selNHID={selectedNHID}
          nhIDs={nhIDs}
          orgNHID={orgNHID}
          />
        <section>
          <div className="container max-w-none 2xl:container mt-4 sm:mt-6 md:mt-8 2xl:mt-10">
            
            {
              isInSinglePropertyMode ? (
                <IndividualPropertyPhotos
                  selectedNHID={selectedNHID}
                  nhIDs={nhIDs}
                />
              ) : (
                <MultiOrOrgPropertyPhotos handleSelectedNHID={setSelectedNHID} />
              )
            }
          </div>
        </section>
      </PhotoFiltersContextProvider>
    </MessagesContextProvider>

  );
};

export default PropertyPhotos;
